import { BasePageListApiQuery } from './base';

/** 行为 */
export declare namespace Behaviors {
  interface DataItem {
    description: string;
    id: number;
    key: EnumBehaviorKey;
    meta: {};
    name: string;
    permission_data: null | [];
  }

  interface ListQuery extends BasePageListApiQuery {
    key?: string;
    name?: string;
  }

  /** 用户关联行为 */
  interface UserBehaviors {
    behaviors: DataItem[];
    username: string;
    user_id: number;
    roles: { role_id: number; role_name: string }[];
  }
}

/** 行为 */
export enum EnumBehaviorKey {
  /** 数据分析 */
  DATA_ANALYZE = '01',
  /** 分析权限管理 */
  ANALYZE_PERMISSION_MANAGE = '02',
  /** 数据责任划分 */
  DATA_RESPONSIBILITY_DIVIDE = '03',
  /** 数据注释维护 */
  DATA_COMMENT_MAINTENANCE = '04',
  /** 数据预览 */
  DATA_PREVIEW = '05',
  /** 数据接入管理 */
  DATA_ACCESS_MANAGE = '06',
  /** 模型资源管理 */
  MODEL_RESOURCE_MANAGE = '07',
  /** 智能体表现优化 */
  AGENT_PERFORMANCE_OPTIMIZE = '08',
  /** 基础数据维护 */
  BASE_DATA_MAINTENANCE = '09',
  /** 数据分析报告 */
  ANALYZE_REPORT = '10',
}
